export const typeKey = 'type'
export const tagsKey = 'tags'
export const domiciledKey = 'domiciled'
export const primaryRegionsKey = 'primary_regions'
export const restrictedJurisdictionsKey = 'restricted_jurisdictions'
export const licensedCountryKey = 'licensed_country'

const checkBoxData = ({ label = '', value = false, key } = {}) => {
  return {
    label,
    value,
    key,
  }
}

const getModalFiltersFields = () => {
  return {
    fiatCurrencyTrading: [
      checkBoxData({ label: 'Yes', key: true }),
      checkBoxData({ label: 'No', key: false }),
    ],
    privacyCoin: [
      checkBoxData({ label: 'Has Privacy Coin', key: true }),
      checkBoxData({ label: 'No Privacy Coin', key: false }),
    ],
    status: [
      checkBoxData({ label: 'Active', key: 'active' }),
      checkBoxData({ label: 'Suspended', key: 'suspended' }),
    ],
    KYCLevel: [
      checkBoxData({ label: 'Required', key: 'required' }),
      checkBoxData({ label: 'Partially Required', key: 'partially_required' }),
      checkBoxData({ label: 'None', key: 'not_required' }),
    ],
  }
}

const getChipsFiltersFields = () => {
  return [
    {
      label: 'Type',
      key: typeKey,
      multiple: true,
      value: [],
      options: [],
    },
    {
      label: 'Tags',
      key: tagsKey,
      multiple: true,
      value: [],
      options: [],
    },
    {
      label: 'Domiciled',
      key: domiciledKey,
      multiple: true,
      value: [],
      options: [],
    },
    // {
    //   label: 'Primary Regions',
    //   key: primaryRegionsKey,
    //   multiple: true,
    //   value: [],
    //   options: [],
    // },
    {
      label: 'Restricted Jurisdictions',
      key: restrictedJurisdictionsKey,
      multiple: true,
      value: [],
      options: [],
    },
    {
      label: 'Licensed Country',
      key: licensedCountryKey,
      multiple: true,
      value: [],
      options: [],
    },
  ]
}

export { getChipsFiltersFields, getModalFiltersFields }
